import { Navigation } from '../../../../Fundraising.UI.Shared/Modules/Navigation';
import { ShopSwitch } from '../../../../Fundraising.UI.Shared/Modules/ShopSwitch';  

export const init = () => {
    const pageHeaderContainer = document.querySelector('.page-header-container');
    const mainNav = document.getElementById('main-nav');
    if (!pageHeaderContainer || !mainNav) return;

    Navigation.create('#menu-trigger', { 
        menuContainerSelector: '.main-nav-container',
        offsetElements: ['.announcement-banner'],
        desktopClickDropdownIds: ['storeNavDropdown'] 
    });

    const shopSelectorContainer = document.querySelector('.shop-selector-container');
    const checkCartContentsUrl = shopSelectorContainer?.getAttribute('data-check-cart-contents-url') || null;
    const clearCartContentsUrl = shopSelectorContainer?.getAttribute('data-clear-cart-contents-url') || null;
    const requestVerificationToken = shopSelectorContainer?.querySelector('input[name="__RequestVerificationToken"]')?.value || '';

ShopSwitch.create('.shop-link', {
        onClick: ()=> {
            const storeChanger = document.querySelector('.shop-changer.nav-item .dropdown-toggle');
            if (storeChanger) {
                (storeChanger).click();
            }
        },
        checkCartContentsUrl: checkCartContentsUrl,
        clearCartContentsUrl: clearCartContentsUrl,
        requestVerificationToken: requestVerificationToken
    });
}